import ImportSidePanel from "components/shared/import-side-panel";
import {
  CustomerImportValidationError,
} from "_interfaces/customer.interfaces";

interface Props {
  isOpen: boolean;
  selectedFile: File | null;
  validationErrors: CustomerImportValidationError[];
  isLoading: boolean;

  onClose: () => void;

  onSelectFile: (
    file: File | null,
  ) => void;

  onRemoveFile: () => void;
  downloadTemplate: () => void;
  onSubmit: () => void;
}

const CustomerImportModal = ({
  isOpen,
  selectedFile,
  isLoading,
  onClose,
  onSelectFile,
  downloadTemplate,
  onRemoveFile,
  onSubmit,
}: Props) => {
  return (
    <ImportSidePanel
      open={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
      onFileSelect={(file) =>
        onSelectFile(file)
      }
      onFileRemove={onRemoveFile}
      selectedFile={selectedFile}
      acceptedFileTypes=".xlsx,.xls"
      submitDisabled={
        !selectedFile ||
        isLoading
      }
      submitLoading={isLoading}
      submitLabel={
        isLoading
          ? "Importing..."
          : "Import"
      }
      title="Import Customer"
      subtitle="Upload customer data in Excel format"
      onTemplateDownload={
        downloadTemplate
      }
      templateFileName="Customer Import Template.xlsx"
    />
  );
};

export default CustomerImportModal;